"use strict";

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Compute numerical integral y' = f(t, y), y(t0) = y0,
 *  start from t0, step size h, with specified number of steps,
 *  with Runge-Kutta Method order 4
 */

function RK4(f, y0, t0, h, steps) {
  var result = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new Array(steps);

  if (steps == 0) {
    return result;
  }

  result[0] = y0;
  var yp = y0;
  var tp = t0;

  for (var i = 1; i < steps; i++) {
    var k1 = f(tp, yp);
    var k2 = f(tp + h / 2, yp + h * k1 / 2);
    var k3 = f(tp + h / 2, yp + h * k2 / 2);
    var k4 = f(tp + h, yp + h * k3);
    var yi = yp + h / 6 * (k1 + 2 * k2 + 2 * k3 + k4);
    var ti = tp + h;
    result[i] = yi;
    yp = yi;
    tp = ti;
  }

  return result;
}

exports.RK4 = RK4;

function linearApproximation(points, t) {
  var i1, i2, k;
  var w = t * (points.length - 1);
  i1 = Math.floor(w);
  i2 = i1 + 1;
  k = w - i1;

  if (i1 < 0) {
    i1 = 0;
    i2 = 0;
  }

  if (i1 >= points.length - 1) {
    i1 = points.length - 1;
    i2 = points.length - 1;
  }

  return points[i1] * (1 - k) + points[i2] * k;
}

exports.linearApproximation = linearApproximation;

function findSegment(bounds, k) {
  // Linear search
  for (var i = 0; i < bounds.length - 1; i++) {
    var b1 = bounds[i];
    var b2 = bounds[i + 1];

    if (k >= b1 && k <= b2) {
      return [i, k - b1];
    }
  }

  if (k < bounds[0]) {
    return [0, 0];
  } else {
    return [bounds.length - 2, bounds[bounds.length - 1] - bounds[bounds.length - 2]];
  }
}

exports.findSegment = findSegment;

function linearInvert(points) {
  var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Array(points.length);
  var s0 = points[0];
  var s1 = points[points.length - 1];
  var ptr = 0;

  for (var i = 0; i < points.length; i++) {
    var si = s0 + (s1 - s0) * i / (points.length - 1);

    while (ptr + 2 < points.length && si >= points[ptr + 1]) {
      ptr += 1;
    }

    var sA = points[ptr];
    var tA = ptr / (points.length - 1);
    var sB = points[ptr + 1];
    var tB = (ptr + 1) / (points.length - 1);
    var ti = (si - sA) / (sB - sA) * (tB - tA) + tA;
    result[i] = ti;
  }

  return result;
}

exports.linearInvert = linearInvert;

var CurveParameterization =
/*#__PURE__*/
function () {
  function CurveParameterization() {
    _classCallCheck(this, CurveParameterization);
  }

  _createClass(CurveParameterization, [{
    key: "getNormalAtT",
    value: function getNormalAtT(t) {
      var tangent = this.getTangentAtT(t);
      return {
        x: -tangent.y,
        y: tangent.x
      };
    }
  }]);

  return CurveParameterization;
}();

exports.CurveParameterization = CurveParameterization;
/** Parametrize a given bezier curve */

var BezierCurveParameterization =
/*#__PURE__*/
function (_CurveParameterizatio) {
  _inherits(BezierCurveParameterization, _CurveParameterizatio);

  /** Construct the cubic bezier curve with four control points */
  function BezierCurveParameterization(p1, p2, p3, p4) {
    var _this;

    _classCallCheck(this, BezierCurveParameterization);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BezierCurveParameterization).call(this));
    _this.k3x = 3 * (p2.x - p3.x) + p4.x - p1.x;
    _this.k2x = 3 * (p1.x + p3.x - 2 * p2.x);
    _this.k1x = 3 * (p2.x - p1.x);
    _this.k0x = p1.x;
    _this.k3y = 3 * (p2.y - p3.y) + p4.y - p1.y;
    _this.k2y = 3 * (p1.y + p3.y - 2 * p2.y);
    _this.k1y = 3 * (p2.y - p1.y);
    _this.k0y = p1.y; // Len = 8.080527392389182  10000
    //       8.080527036296594  100
    //       8.084824756247663  10

    var steps = 100;
    _this.tToS = RK4(function (t, y) {
      return _this.getDsDtAtT(t);
    }, 0, 0, 1 / (steps - 1), steps);
    _this.len = _this.tToS[steps - 1];
    _this.sToT = linearInvert(_this.tToS);
    return _this;
  }

  _createClass(BezierCurveParameterization, [{
    key: "getPointAtT",
    value: function getPointAtT(t) {
      return {
        x: this.k0x + t * (this.k1x + t * (this.k2x + t * this.k3x)),
        y: this.k0y + t * (this.k1y + t * (this.k2y + t * this.k3y))
      };
    }
    /** Get the tangent direction at t */

  }, {
    key: "getTangentAtT",
    value: function getTangentAtT(t) {
      var t2 = t * t;
      var dxdt = 3 * t2 * this.k3x + 2 * t * this.k2x + this.k1x;
      var dydt = 3 * t2 * this.k3y + 2 * t * this.k2y + this.k1y;
      var length = Math.sqrt(dxdt * dxdt + dydt * dydt);
      return {
        x: dxdt / length,
        y: dydt / length
      };
    }
    /** Get ds/dt at t */

  }, {
    key: "getDsDtAtT",
    value: function getDsDtAtT(t) {
      var t2 = t * t;
      var dxdt = 3 * t2 * this.k3x + 2 * t * this.k2x + this.k1x;
      var dydt = 3 * t2 * this.k3y + 2 * t * this.k2y + this.k1y;
      return Math.sqrt(dxdt * dxdt + dydt * dydt);
    }
  }, {
    key: "getSFromT",
    value: function getSFromT(t) {
      return linearApproximation(this.tToS, t);
    }
  }, {
    key: "getTFromS",
    value: function getTFromS(s) {
      return linearApproximation(this.sToT, s / this.len);
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this.len;
    }
  }]);

  return BezierCurveParameterization;
}(CurveParameterization);

exports.BezierCurveParameterization = BezierCurveParameterization;

var LineSegmentParametrization =
/*#__PURE__*/
function (_CurveParameterizatio2) {
  _inherits(LineSegmentParametrization, _CurveParameterizatio2);

  function LineSegmentParametrization(p1, p2) {
    var _this2;

    _classCallCheck(this, LineSegmentParametrization);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(LineSegmentParametrization).call(this));
    _this2.p1 = p1;
    _this2.p2 = p2;
    _this2.length = Math.sqrt((p2.x - p1.x) * (p2.x - p1.x) + (p2.y - p1.y) * (p2.y - p1.y));
    _this2.tangent = {
      x: (p2.x - p1.x) / _this2.length,
      y: (p2.y - p1.y) / _this2.length
    };
    return _this2;
  }

  _createClass(LineSegmentParametrization, [{
    key: "getTangentAtT",
    value: function getTangentAtT(t) {
      return this.tangent;
    }
  }, {
    key: "getPointAtT",
    value: function getPointAtT(t) {
      return {
        x: this.p1.x + (this.p2.x - this.p1.x) * t,
        y: this.p1.y + (this.p2.y - this.p1.y) * t
      };
    }
  }, {
    key: "getSFromT",
    value: function getSFromT(t) {
      return t * this.length;
    }
  }, {
    key: "getTFromS",
    value: function getTFromS(s) {
      return s / this.length;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this.length;
    }
  }]);

  return LineSegmentParametrization;
}(CurveParameterization);

exports.LineSegmentParametrization = LineSegmentParametrization;

var MultiCurveParametrization =
/*#__PURE__*/
function () {
  function MultiCurveParametrization(segments) {
    _classCallCheck(this, MultiCurveParametrization);

    this.segments = segments;
    this.len = 0;
    this.sBounds = new Array(this.segments.length + 1);
    this.sBounds[0] = 0;

    for (var i = 0; i < this.segments.length; i++) {
      this.len += this.segments[i].getLength();
      this.sBounds[i + 1] = this.len;
    }
  }

  _createClass(MultiCurveParametrization, [{
    key: "getSegmentAtS",
    value: function getSegmentAtS(s) {
      var _findSegment = findSegment(this.sBounds, s),
          _findSegment2 = _slicedToArray(_findSegment, 2),
          pi = _findSegment2[0],
          ps = _findSegment2[1];

      var p = this.segments[pi];
      var pt = p.getTFromS(ps);
      return [p, pt];
    }
  }, {
    key: "getPointAtS",
    value: function getPointAtS(s) {
      var _this$getSegmentAtS = this.getSegmentAtS(s),
          _this$getSegmentAtS2 = _slicedToArray(_this$getSegmentAtS, 2),
          p = _this$getSegmentAtS2[0],
          t = _this$getSegmentAtS2[1];

      return p.getPointAtT(t);
    }
  }, {
    key: "getTangentAtS",
    value: function getTangentAtS(s) {
      var _this$getSegmentAtS3 = this.getSegmentAtS(s),
          _this$getSegmentAtS4 = _slicedToArray(_this$getSegmentAtS3, 2),
          p = _this$getSegmentAtS4[0],
          t = _this$getSegmentAtS4[1];

      return p.getTangentAtT(t);
    }
  }, {
    key: "getNormalAtS",
    value: function getNormalAtS(s) {
      var _this$getSegmentAtS5 = this.getSegmentAtS(s),
          _this$getSegmentAtS6 = _slicedToArray(_this$getSegmentAtS5, 2),
          p = _this$getSegmentAtS6[0],
          k = _this$getSegmentAtS6[1];

      return p.getNormalAtT(k);
    }
  }, {
    key: "getFrameAtS",
    value: function getFrameAtS(s) {
      var _this$getSegmentAtS7 = this.getSegmentAtS(s),
          _this$getSegmentAtS8 = _slicedToArray(_this$getSegmentAtS7, 2),
          p = _this$getSegmentAtS8[0],
          t = _this$getSegmentAtS8[1];

      return {
        p: p.getPointAtT(t),
        t: p.getTangentAtT(t),
        n: p.getNormalAtT(t)
      };
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this.len;
    }
  }, {
    key: "getSegments",
    value: function getSegments() {
      return this.segments;
    }
  }]);

  return MultiCurveParametrization;
}();

exports.MultiCurveParametrization = MultiCurveParametrization;